import React from "react";
import DownloadByYear from "../../../components/lamppost/download-year";

const DownloadYearPage = () => (
    <DownloadByYear lang="tc" path="download/year" />
);

export default DownloadYearPage;
